export default __webpack_public_path__ + "static/artistBox-vee-sensei-9e7f9d8196d80fcf1284c194912634ee.png";